@if (showLoader()) {
  <div class="loading-container">
    <app-loading></app-loading>
  </div>
}

@if (!showTutorial() && shouldShow()) {
  <div class="welcome-wrapper">
    <div
      class="form-card items-center flex-column"
      [ngClass]="{ 'badging-questions-container': !showWelcomeDeviceSelectionForm() }"
    >
      <!-- Title -->
      <div class="welcome-header">
        @if (showWelcomeDeviceSelectionForm()) {
          <div>
            <h3 class="title">
              Welcome to <br />
              {{ roomName }}
            </h3>
            @if (connectedRoomSet && connectedRoomSet.length > 1) {
              <span class="subtitle">
                {{ roomsName }}
              </span>
            }
          </div>
        }
        @if (showSmartBadging() && !showWelcomeDeviceSelectionForm()) {
          <div>
            <div>
              <h3 class="title">
                Smart Badge Preview
                <mat-icon [matMenuTriggerFor]="menu" #t="matMenuTrigger" (mouseenter)="t.openMenu()">help</mat-icon>
                <mat-menu #menu="matMenu">
                  <div class="help-tooltip-content">
                    <span>
                      Smart Badging provides insights into fellow attendees, helping you discover and connect with
                      people who matter most to you.
                      <a href="https://help.scoot.app/smart-badging" target="_blank" rel="noopener noreferrer"
                        >Learn More</a
                      >
                    </span>
                  </div>
                </mat-menu>
              </h3>
            </div>
            <div>
              <span class="subtitle">
                {{ isGuest ? 'Please Enter Smart Badge Information' : 'Please Review Your Smart Badge' }}
              </span>
            </div>
          </div>
        }
      </div>
      <!-- Sidebar/main card -->
      <div class="welcome-content">
        @if (showWelcomeDeviceSelectionForm()) {
          <div class="device-form-container desktop">
            <!-- Form components go here - Devices, etc -->
            @if (showWelcomeDeviceSelectionForm()) {
              <app-welcome-devices-form [user]="user" [canUserJoin]="canUserJoin()"></app-welcome-devices-form>
            }
          </div>
          <div class="info-card mobile">
            <app-welcome-preview [user]="user"></app-welcome-preview>
          </div>
          <div class="buttons-container flex flex-line justify-center items-center">
            <button
              id="joinSocialButton"
              [disabled]="!canUserJoin()"
              data-testid="join-social-button"
              class="rounded"
              type="button"
              mat-button
              [ngStyle]="{ background: event?.buttonColor, color: event?.buttonTextColor }"
              [ngClass]="{
                'secondary-button': showPermissionHelp,
                'primary-button': !showPermissionHelp,
              }"
              (click)="continueBehavior()"
            >
              {{ joinButtonText }}
            </button>
            @if (showPermissionHelp) {
              <button
                id="checkPermissionsButton"
                data-testid="check-permissions-button"
                class="primary-button rounded"
                type="button"
                mat-button
                (click)="showPermissionsExplanationModal()"
              >
                Check Permissions
              </button>
            }
          </div>
          @if (showPermissionHelp) {
            <div class="permission-footer">
              <span>{{ formFooterText }}</span>
              <div [innerHTML]="helpLink"></div>
            </div>
          }
        }
        @if (showSmartBadging() && !showWelcomeDeviceSelectionForm()) {
          <app-badging-questions
            [socialRoomSetId]="socialRoomSetId"
            [event]="event"
            [isOnboardingExperience]="badgeQuestionsStep()"
            (joinSocial)="continueBehavior($event)"
          ></app-badging-questions>
        }
      </div>
      <div class="welcome-footer desktop">
        <ng-container *ngTemplateOutlet="pageFooter"></ng-container>
      </div>
    </div>
    <!-- Content outside card -->
    <div class="welcome-footer-mobile mobile">
      <ng-container *ngTemplateOutlet="pageFooter"></ng-container>
    </div>
    <div
      class="info-card desktop"
      [ngClass]="{ 'handle-preview': showSmartBadging() && !showWelcomeDeviceSelectionForm() }"
    >
      <app-welcome-preview
        [user]="user"
        [showSmartBadging]="showSmartBadging()"
        [smartBadgingHasQuestions]="smartBadgingHasQuestions()"
        [showWelcomeDeviceSelectionForm]="showWelcomeDeviceSelectionForm()"
        [showOrientationStep]="showOrientationStep()"
      ></app-welcome-preview>

      @if (!demoCompleted() && onboardingExperience()) {
        <div class="theme-color-panel" style="--color: {{ themeBackgroundColor() }}"></div>
      }
    </div>
  </div>
  @if (showOrientationStep()) {
    <div class="orientation-info" style="--color: {{ backgroundDivColor() }}">
      “Here you’ll see a preview of what your Smart Badge will look like in the room.”
    </div>
  }
}

@if (showTutorial() && !onboardingExperience()) {
  <room-tutorial
    (completeEvent)="onTutorialCompleted()"
    [title]="'How to Move'"
    [showSkip]="true"
    [cards]="tutorialCards"
    [type]="0"
  ></room-tutorial>
}

@if (showTutorial() && onboardingExperience() && showOnboardingExperience() && !isMobile()) {
  <app-onboarding-experience
    [user]="user"
    [social]="social()"
    [showSmartBadging]="showSmartBadging() && smartBadgingHasQuestions()"
    (finishOnboardingExperience)="finishOnboardingExperience($event)"
    [shouldContinueFromSmartBadging]="shouldContinueFromSmartBadging()"
  ></app-onboarding-experience>
}

<!-- Footer content -->
<ng-template #pageFooter>
  <div class="footer-content">
    <span class="footer-text"> Powered by </span>
    <img class="footer-logo" src="../../../../../assets/images/logos/horizontal-navy-3-color.svg" alt="Scoot Logo" />
  </div>
</ng-template>
